export const CollectionListStaticList = [
	{
		imageUrl:
			"https://img.seadn.io/files/070b7ca4bb51d07d6b6f776bcb1eed56.jpg?fit=max&w=600",
		name: "Bong Bear #21",
		description: "100 absolutely zooted NFT bears getting baked.",
	},
	{
		imageUrl:
			"https://img.seadn.io/files/42d7f18f0bfbee81dd18ac431339c52e.png?fit=max&w=600",
		name: "GLASS",
		description:
			"Glass is about the illusion of simplicity that cocoons us in our everyday existence. A glance at Glass may suggest a foam of bubbles or pebbles under clear water. But on inspection, these simple pictures dissolve. Instead of disks one finds stacked panes of translucent glass, intersecting and overlapping. There is dissonance between fine-scale chaos and the harmony of the aggregate. In Glass, two levels of reality -- panes of glass and the foam of bubbles -- are brought close together in scale, so that our oversimplified impression yields a palpable disquiet.",
	},
	{
		imageUrl:
			"https://img.seadn.io/files/2b60ecf4b5dec49a6cae891db67ce2e0.jpg?fit=max&w=600",
		name: "Bong Bear #35",
		description: "100 absolutely zooted NFT bears getting baked.",
	},
	{
		imageUrl:
			"https://res.cloudinary.com/demo/image/fetch/h_500/https://arweave.net/yfKRJ1yYkNuCduMPVFY6wY16MiKq-nH_5_NfnHw3ItE",
		name: "THUG #2303",
		description: "",
	},
	{
		imageUrl:
			"https://res.cloudinary.com/demo/image/fetch/h_500/https://arweave.net/jpL3mrFaZnQbjzViNn8KV5HXv_hjRnkZYErg0ZTAUDk",
		name: "Degen Ape #8160",
		description: "",
	},
	{
		imageUrl:
			"https://res.cloudinary.com/demo/image/fetch/h_500/https://ipfs.io/ipfs/QmP32X3tAKmACt7j9LM1KMVx32BmVqhTqcuWcrCX3tUDAv",
		name: "Fiend#59",
		description: "",
	},
	{
		imageUrl:
			"https://res.cloudinary.com/demo/image/fetch/h_500/https://arweave.net/sHgnTqlkeGtnGS5cuNWcpf-7Pg42hm2YVjfOWag8AOk",
		name: "Aurorian #8480",
		description: "",
	},
	{
		imageUrl:
			"https://res.cloudinary.com/demo/image/fetch/h_500/https://www.arweave.net/6jkL5ag6f6k_X0dAsK_WzogeeOTb7Pbp_VBhGxSyvQo",
		name: "Frakt-5954",
		description: "",
	},
	{
		imageUrl:
			"https://res.cloudinary.com/demo/image/fetch/h_500/https://metadata.degods.com/g/2573.png",
		name: "DeGod #2574",
		description: "",
	},
	{
		imageUrl:
			"https://res.cloudinary.com/demo/image/fetch/h_500/https://arweave.net/ym-OszXK-_jN8IhjmtKbomCIDY9WK2iRN-kG4auLCec?ext=gif",
		name: "Genesis Habitat #3099",
		description: "",
	},
	{
		imageUrl:
			"https://res.cloudinary.com/demo/image/fetch/h_500/https://arweave.net/Uj_0XrBAgspQntyxJT8fb7i_gQ9-geGoe-Gx52zcmwY",
		name: "ABC #6499",
		description: "",
	},
	{
		imageUrl:
			"https://res.cloudinary.com/demo/image/fetch/h_500/https://ipfs.io/ipfs/bafybeietgmh66gwgtfog2x6bun22zbpoe7jopeclje4n3czqjdjvwtispq/692.png",
		name: "Bobo 693",
		description: "",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/oKIDmZDmB4pUkAXhhpsJPS8LVveVvuM-M8uWM2XwSet5BmH157ViYIvKV0KbzlNeIdXWkHIOWTAC8V_M1Jg6jPipYNN1OqSAzE3M2jU=w600",
		name: "MOUS IN DA HOUS #623",
		description:
			"Its da 44TH Street man! A lot of MOUS chilling on their personal subway station surrounded by drugs, lottery, black markets & hella party! If you're in da city feel free to enter da 44TH. P.S. $44TH only",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/fMsG3jmSuVjTSzf673mvc2LiYmi5VMY3t9hkUN2QsnggSsTkD6vdmefaQmsd-MoylEOJz14rWCn7wOKftqLrznldiZv8exUHKl8pYw=w600",
		name: "LIFINITY Flares #9816",
		description:
			"Lifinity Flares is a set of 10,000 animated NFTs that directly combine NFTs with DeFi. They are designed to bootstrap liquidity on Lifinity and perpetually create value for the holders. All sale proceeds are deposited into Lifinity's liquidity pools. Royalties and trading fees are either used to buy back Lifinity Flares or are reinvested into the pools. The team takes zero profit. All value accrues to NFT holders.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/sGetrnTeJ-vcsxuS2sv94F3rwkq3bd-m1yMkULxufqQpscvYbSk7lsFw9daQxG0xnfiLTGjCdMGMp9qhgCJjFz4eL8ipFPcOWio3=w600",
		name: "Keycard #2258",
		description:
			"Keycards are the way to enter the Psykerverse. Keycard holder benefits include: closed beta access, DAO membership, and a genesis character loadout.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/moXjcBVwweSgf4CFNw7M4S7GB3LcLYVf0mWReD1xbHg59wyqbTpD65Oxz0j16p4AIz6zloGzSs3zdLK-WeFdVqanDGavTA0lVX8JQYE=w600",
		name: "FloppyLabs #29",
		description:
			"Solana Staking as a Self-Service platform. Revenue sharing with FloppyHeads holders.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/JJO4yvWKbacCTKe-QY9vkL4XDc5wrxDwnu76D9WXDUQIp1V8HITYaJaHlzn71mA8X2wJceR1J8zL-PlSBTiF44-DtPo2l2q8vvSfvA8=w600",
		name: "Fish #3994",
		description:
			"Smart Sea Society is building the world's first AI driven NFT platform. Twitter/ME Analyses, Floor Price Predictions and Automated Signals + Snipes.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/K0Ugkq5PYzb2ybQPOTXevj09Rf2Tp00HiHfMduSFFszJJk4X9pwguGbQpTRA0BiKqrSqbW27TMqxa95u1D89fGfSS2k05PLei2FThw=w600",
		name: "Not Bored Ape #5863",
		description: "Apes on SOL because ETH is boring",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/W_-0AX6sisvylCAy28R8m6UT9wGa9p1PSpXKC3HpO4pZzk1d_fh1wVUO00Cbfo1S5j-wNfUWdCwJ4H1UgsqDhPMwfKu9aBQ3YLuAXA=w600",
		name: "Not Bored Ape #3577",
		description: "Apes on SOL because ETH is boring",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/_VLkh04cC31U1nqIGallQRkUmkc8GmaxeY572gP-MYbVKW55FFzISNP5Hvd0TQYRImqf0n7oDcKWA42rtiH0azOIRUdzRK3KAy6f2w=w600",
		name: "Not Bored Ape #1769",
		description: "Apes on SOL because ETH is boring",
	},
	{
		imageUrl:
			"https://openseauserdata.com/files/fbfb27b99e88babe6f68db6eb5620aae.gif",
		name: "HydraScripts #229",
		description: "The revolutionary NFT extension",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/PyeXm68ApPr55tt_ivCM2m-P0KHCco1k8h0-dN_AVDIpj_VJ1qj99CT7qe-3cHoD1N1ye7M051b5jKkrReLUfyubJGtM2gv2Z5cGOA=w600",
		name: "The Stone Heads #717",
		description:
			"The Stone Heads is a collection of 5,555 unique NFTs launched on the Solana blockchain, and representing a connection between classic and contemporary art, bringing iconic characters from the mythology to the Metaverse.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/l7IUpw8VnV0-Q7fpaiUPo0YV6jDzKJKfyz0XRNQTjIK_lLmzbV5uHBCJF1lvNahQGNdeKBFH_peHZrV52Crj_gj3rJ4y2K0T_mvyajY=w600",
		name: "The Stone Heads #3459",
		description:
			"The Stone Heads is a collection of 5,555 unique NFTs launched on the Solana blockchain, and representing a connection between classic and contemporary art, bringing iconic characters from the mythology to the Metaverse.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/OwPHnykhndHfvPJKVMPUlZxfj570a_1ikY0vb5fEjXitdEYxHwPC7XJPm75bRh8dAF2Qn6qA1geJ113Dsp4lBMDcsL1bSsFETdQQ5yg=w600",
		name: "The Stone Heads #715",
		description:
			"The Stone Heads is a collection of 5,555 unique NFTs launched on the Solana blockchain, and representing a connection between classic and contemporary art, bringing iconic characters from the mythology to the Metaverse.",
	},
	{
		imageUrl:
			"https://img.seadn.io/files/4c744dfd877ffcce344fa2c1a8b0dd7e.jpg?fit=max&w=600",
		name: "bloodtree(no.2)",
		description: "By Projectcrack_",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/HChj_cTsr6y74lcBwM8ZBa7jwVqhWyFxj4LeRKwmaxnQS-5r1tXWWBQ480vmVTwjf4yKLT7heIC14LzRMeihPlcKqwUPk8LdlusnGOo=w600",
		name: "Frakt-5385",
		description: "By FRAKT",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/rLoz8ZVQUbhyUX2iDaTdFgEeCzmbtgnp8bX1ZbQ9OxQn6oUWkhvl9MEJ4WCD43XqmDWikD-pqVkjjmLLc26tGXv5NKjwwOuSIW6v7co=w600",
		name: "Bohemian #1729",
		description:
			"This Bohemian is your proof of membership to the galleries of Bohemia. Wander through Bohemia and discover the wonders of art.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/R13tNzAcQAfG0tKsfovLzkkcxt5gbH6wjVBxOr64XxQvP9rbkAYRC-dt_1kS92vNmoENaWpMCmDFjPtASV7PhGaVhQo7rYrh5tNzGv0=w600",
		name: "glaba 1",
		description: "By pebLoU",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/gQS9xRBRU9qiJL06Mvja7cas7WuQg87caJ_hROLyQRzAxeCYmNOUaVxe7pGrmBiwujwt6cZy7MT88Jf2jQ3zkX_uuxD2iTnrsQXy=w600",
		name: "Sphynx #1938",
		description:
			"The Sphynx Underground is a unique Society that focus on the growth of its own members on Metaverse.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/4Wps2Bm-9dfweoL6iVkGlBmVyZ3tvSyF2DFoWGmR2qCBcbvXsXgvLO84wlRkwxH8i2F_9_4fZGLEpHBUZgVelE8F6DDl_qyGLnL8ig=w600",
		name: "6 RINGS #198889770027",
		description:
			"The HEIR 6 RINGS NFT is a limited edition NFT that grants collectors early access to special experiences exclusively launching on HEIR, along with rare Founding Member perks and benefits.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/kBTlb7CXBYsyv35bbxuIMHCNAMl2cZT2DcmL3vP7crygq4coBYcYk8QUbKW4DFDXPk3-kChT5Pu5wwMX95XqXK6uxC4kgkeH6gwvDg=w600",
		name: "Rarikey #1991",
		description:
			"2,600 unique Rarikeys allowing you to be part of SolRarity journey in the Solana ecosystem. Hold these precious keys to unlock access to premium tools and more... ",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/Inj5AvHBnpdBuIso_WmTkGUTO8djr4IfQJb-qEPgqFr-i7VRZZmrHrQAw76-RNlMSbeChWXekvZcdp6XHrww_9SV1l2cPshgnKNzZw=w600",
		name: "TYR-Infant-1213",
		description: "Taiyo infant hatched after 30 days of Incubation",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/76M_db_kLqVvDRYRLGYUPxc65l2BhmX4z6KBSCW9bDq8Dha8JN0dLC4hN113gBhDmp8ZLoZj4z0FVGt1uR-ZjNMIx-wEFgiaOHwZEQ=w600",
		name: "Shadowy Super Coder #6774",
		description:
			"To this group of randomly generated Shadowy Super Coders... that sounds a lot better.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/3YpcWe4LoQRxjqKQsH5xnku8ILQESp_nSoBjwzJEkU8TjjbAaW8q7Fz1klcZOq7X18JuVzncyeD5WwW5mMQguP1jpOqZXRlm858slw=w600",
		name: "Stylish Stud #7086",
		description:
			"The Stylish Studs are a collection of 10,000 unique NFT's - digital collectibles racing around the blockchain.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/GG1gYXyzuX4az0XTbJNfzusQFgAblmnN-HIBFzLE1dz-VL5kXebI_9CJCPtGvLtapjPe8bUr1-EmCxM4b450_avNIVXByVgC8tUPtQ=w600",
		name: "Monke #1563",
		description: "A collection of 6000 very handsome Rejects.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/mC97EnnKBY9lqXh5gyyzJaJN-xMsLVBLtWJ32qdjafdMM24uqMaVvL6OjsyBiKH4U2PoNX_5o3u0xtQlbOK1TOkKLwAdQ_ijIfNdlZ8=w600",
		name: "AiriA | Tier 01 #4839",
		description:
			"Existing as an NFT, AiriA is a premium, photorealistic & customizable metaverse space.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/cyJk1Vm-_vMjCi1D9pg2Nt7qewb-SWMTU5XW8o0mf5fHG8t3Ml-nrR6kdUyhahZw6b-R5YN4t8RruMyLtrYIvAymgFWiuZasA5UAEUA=w600",
		name: "The Orcs #3399",
		description: "8888 Orcs from the Genesis Collection invaded the Solana.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/U1AfpO5NDST6ivk5ZcltVWZsLeXdDeiIAc6yACK-K0lVizBfE5U4lXkdxjZcwR7QHjMRxUsrOF5-96LCSjN6EO4sDm4mkP4KHhUbUw=w600",
		name: "Gameroom #253",
		description: "Collection of 6,666 gamerooms on the blockchain.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/lE4jxBxeAIc_l0EMYMi360WN1td_r0xGyXLcJHqh0YY8nf-1om9xwnc5J-k-zUUWHPUV2PQLaQ3JVh1SNmnTS9WNJgykI78W2MM1lw=w600",
		name: "Galactic Gecko #3590",
		description:
			"Eyeing the competition pulling up to the starting line, you feel deep within that you're the best gecko there - or, and this is no surprise for a Martu racer, the most cunning. Wait until your rival figures out what you did to their spaceship.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/IlGAJaPoR5TSumzS6vm6oG76ykFNNnxk6HcYezBrR3joLMiZyoVLT20cxrej2SGGuXVerLnKAZ_7oqcd5LNgxDen21PjaOdf4FOm=w600",
		name: "melk bottle",
		description: "",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/R9CjrPMi5x4xY668bS-RyFgOEsRNBlhonNczjD1-QjwOoJpgjkqBdlZzv45ZFB1eDif3HY8zojV-RVlTEOdMXESuuhNtYOyuxgXv=w600",
		name: "Taiyo Oil #900",
		description: "Oil.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/uVkkpaj7sOblUzZYouZLQdSh6r8ohPrvDokiiAI9hmiPrpYg6NcCrF1i-3oRwm6kVZs1rYE2Z5EMFvfBU68hcaiDG0b04ooQIbKHsUc=w600",
		name: "OG Atadians #1064",
		description:
			"Atadia is a collective analytics NFT project centered around a lore-filled, post-singularity world. Holders receive pencil-drawn PFP art, exposure to drive and share the success of our analytics business, and $ATA passive income with turn-based alternate reality game mechanics.",
	},
	{
		imageUrl:
			"https://img.seadn.io/files/6956e1336edda9604e09b0765790b795.png?fit=max&w=600",
		name: "DeGod #4797",
		description: "10,000 of the most degenerate gods in the universe.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/TKNU0-q5ngDI1UpbL7UIAMcQFzo8se0xwUmivBjzDvZN76DOMoYXNWzL4sh0-2l8EhfHuS0Z-FOvP77B85eVAhmjX2FHvSiBRm5IU0I=w600",
		name: "Block City 11B [-80, 380]",
		description:
			"The parcel is located on the edge of the Block City zone of Heaven Land with coordinates X=-80m Y=380m relative to the centre of its cluster. The parcel supports buildings of a maximum height of 25m and a depth of 2m. It has a size of 25mx25m (625m²) as any other parcel in Heaven Land.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/8jU78Wb0G5YR2g4bDU0irRGSK8VzgM1QY5kPpZ9XzNA2KKqpEWlcdkQGalRuZojtPyaoJ3eKdC5jnczXw4ElrB7Esk1XXS7n6y5G3g=w600",
		name: "Spore",
		description: "Chorles' primordial gift. The journey begins.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/iXbWj67vYf-487l3SEzh5yIL8wpaCL3qPldHjs2KRJUkuPwkxPuO6uaQgs1dsauWq0BbE8hMTsrD3p5F7EWyadVE90qeSBXesWHZcQ=w600",
		name: "Zenjin Viperz #1793",
		description:
			"Zenjin Viperz are an exclusive collection of 2,000 NFTs on the Solana Blockchain.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/51q02QuJiZNoA8oYbLxxrciei1noj5Bxr94GnObY74FHqEyDFRkfziZT86HmRUe5BEy6-P0i5uG24dgbS0m6aGH0_M3LszjM7f3cXA=w600",
		name: "VBA | Season0 Pack #882",
		description:
			"The VBA is the first web3 basketball manager game. Build the team of your dreams, compete in weekly tournaments, and win real rewards.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/jD00mZEFZtDUy_rnpE73E3mTZEWO58Gc1V8AZxa1jzm_L7hdj8Hvru69vMjCG7oQT3D3NSeLx6qSJrBpBa3GNExUgNHDhBWiaU4az-I=w600",
		name: "Node Monkey #81",
		description:
			"255 Node Monkey's entering the Solana network with utility to access a private RPC validator node with IP whitelisting to prevent leaking. 227 Renewals, 23 1/1 Lifetime passes, 5 Animated Legendaries.",
	},
	{
		imageUrl:
			"https://lh3.googleusercontent.com/ifW0PI7dSdqJrrhRmcbxGH8JT_VdRC1CkTbfpq1xtks1S1VQcIDHm81k1zgRWGqMjPcsd7V4yuMc8fO7QFnU8IU46iRm4ctoCfXY1A=w600",
		name: "Grim #4710",
		description:
			"The Grim Syndicate is a collection of 10,000 generated Grims that do the dirty work of playing afterlife janitors across all planes of existence; in fetching those stubborn Souls who vacate their living vessels but aren’t ready to move on to the Ethereal Realm. What you call a haunting, these Reaper Agents call “all in a day’s work”.",
	},
];

export const PageRoutes = {
	Home: "/",
	Details: "/details",
	CollectionDetails: "/collection",
	Trending: "/trending",
	Collection: "/:public_key",
};
